import React from 'react';
const bonuses = [{
  title: 'Poolside Quick Plan Cards™',
  description: '30 ready-to-use planning cards to build a complete lesson in under 3 minutes — even on your most hectic days.'
}, {
  title: 'Swim Lesson First-Class Blueprint™',
  description: "The exact structure for delivering a flawless first lesson that builds trust, reads the swimmer's level, and creates immediate confidence."
}, {
  title: 'Swim Cue Cheat Sheets™',
  description: '100 expert teaching phrases organised by stroke, skill, and swimmer type — so your students understand faster and correct quicker.'
}, {
  title: 'Confident Coach Class Checklist™',
  description: 'Your pre-class, during-class, and post-class checklist system to walk onto the pool deck prepared, focused, and in full control every single session.'
}, {
  title: 'Parent & Student Progress Notes Kit™',
  description: 'Professional progress tracking templates to show measurable results to parents and students — and position yourself as the premium coach in your area.'
}];
const benefits = [{
  emoji: '⚡',
  title: 'Save Hours Every Week',
  desc: 'Stop creating lessons from scratch. Open the system, choose the session, and teach with confidence from minute one.'
}, {
  emoji: '👑',
  title: 'Greater Professional Confidence',
  desc: 'Know exactly what to teach, how to progress your swimmers, and how to adapt classes safely for every level and age group.'
}, {
  emoji: '🦵',
  title: 'Better Swimmer Results',
  desc: 'Structured programs focused on technique, breathing, coordination, water confidence, and real measurable improvement.'
}, {
  emoji: '😊',
  title: 'Higher Engagement & Retention',
  desc: 'Keep students motivated and parents impressed with progressive programming and professional communication tools.'
}];
export function BonusSection() {
  return <>
      <section className="py-8 px-4 sm:px-6 bg-white" data-id="element-15">
        <div className="text-center mb-6" data-id="element-16">
          <h2 className="text-2xl sm:text-3xl font-heading font-black text-brand-navy mb-2 uppercase leading-tight" data-id="element-17">
            5 PREMIUM BONUSES INCLUDED
          </h2>
          <p className="text-sm sm:text-base font-bold text-brand-pool mb-2" data-id="element-18">
            Plus, you'll receive 5 premium bonuses
          </p>
          <p className="text-sm text-brand-navy/80 leading-snug" data-id="element-19">
            Exclusive resources designed to save even more time and deliver
            better results.
          </p>
        </div>

        <div className="flex flex-col gap-3 mb-5" data-id="element-20">
          {bonuses.map((bonus, i) => <div key={i} className="bg-brand-gray border-2 border-brand-pool/30 p-4 rounded-md text-center shadow-sm" data-id="element-21">
              <p className="text-[11px] font-bold text-brand-orange mb-1 tracking-wider uppercase" data-id="element-22">
                🎁 BONUS {i + 1} — FREE
              </p>
              <h3 className="text-sm font-bold text-brand-navy mb-1 leading-tight" data-id="element-23">
                {bonus.title}
              </h3>
              <p className="text-xs text-brand-navy/80 leading-snug" data-id="element-24">
                {bonus.description}
              </p>
            </div>)}
        </div>

        <p className="text-center font-bold text-brand-orange text-sm uppercase tracking-wide bg-brand-orange/10 py-2.5 rounded-md" data-id="element-25">
          The 5 bonuses are FREE with your purchase today.
        </p>
      </section>

      <section className="py-8 px-4 sm:px-6 bg-brand-gray border-t-4 border-white" data-id="element-26">
        <h2 className="text-2xl sm:text-3xl font-heading font-black text-center text-brand-navy mb-2 uppercase leading-tight" data-id="element-27">
          WHAT IS GOING TO CHANGE
        </h2>
        <p className="text-sm sm:text-base font-bold text-center text-brand-pool mb-2" data-id="element-28">
          What will change in your professional life
        </p>
        <p className="text-sm text-center text-brand-navy mb-5 font-bold" data-id="element-29">
          Real benefits starting from your very first week:
        </p>

        <div className="flex flex-col gap-3" data-id="element-30">
          {benefits.map((item, i) => <div key={i} className="bg-white border-l-4 border-brand-orange p-4 rounded-r-md shadow-sm flex gap-3 items-start" data-id="element-31">
              <div className="text-xl shrink-0 leading-none mt-0.5" data-id="element-32">
                {item.emoji}
              </div>
              <div data-id="element-33">
                <h3 className="text-sm font-bold text-brand-navy mb-1 uppercase tracking-tight" data-id="element-34">
                  {item.title}
                </h3>
                <p className="text-brand-navy/80 text-sm leading-snug" data-id="element-35">
                  {item.desc}
                </p>
              </div>
            </div>)}
        </div>
      </section>
    </>;
}